import React from 'react';
import FollowUpAgenciamentoRegistrationPageBase from './FollowUpAgenciamentoRegistrationPageBase';

export default function FollowUpAgenciamentoRegistrationImportAereoPage(props) {
  return (
    <FollowUpAgenciamentoRegistrationPageBase
      {...props}
      urlPosSalvar={(created) => `/importacao/agenciamento/aereo/follow-up?processo=${created?.numero || ''}`}
      breadcrumbConfig={(t, actionName) => [
        {
          link: { to: '/', name: t('com.muralis.qcx.inicio') },
        },
        {
          link: { to: '/importacao/agenciamento/aereo', name: 'Importação Agenciamento Aéreo' },
        },
        {
          link: { to: '/importacao/agenciamento/aereo/follow-up', name: 'Follow-Up' },
        },
        { text: { name: t('com.muralis.qcx.registro') } },
        { text: { name: actionName } },
      ]}
    />
  );
}
